import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Criar conta")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Insira seus dados e crie sua conta Obmed")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "register-personal-title" }, "Dados pessoais", -1)
const _hoisted_5 = { class: "register-personal-content field is-grouped is-grouped-multiline" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nome completo ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Como prefere que te chamemos? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CPF ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Data de nascimento ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Celular ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Sexo")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Voltar")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cadastrar")

import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useHead } from "@vueuse/head";
import { useStore } from "vuex";

import { ObModal, ObRadio, ObInputText, ObSubmitButton, ObCancelButton } from "@/libs/components";

import { formatCPF, addDateMask, formatPhone, sexOptions } from "@/libs/utils";
import { removeDateMask, removeCPFMask, removePhoneMask } from "@/libs/utils";

import { UserPersonalForm } from "@/store/user/types";
import { useRegisterLoginValidators, useRegisterPersonalValidators } from "./mixins";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

useHead({ title: "Criar conta | obmed" });

const store = useStore();
const router = useRouter();

const { checkLoginForm } = useRegisterLoginValidators();
const { checkPersonalForm } = useRegisterPersonalValidators();

const form = reactive<UserPersonalForm>({
  nm_pessoa_fisica: store.state.user.registerForm?.nm_pessoa_fisica || "",
  nm_apelido: store.state.user.registerForm?.nm_apelido || "",
  nr_cpf: store.state.user.registerForm?.nr_cpf || "",
  nr_telefone: store.state.user.registerForm?.nr_telefone || "",
  dt_nascimento: store.state.user.registerForm?.dt_nascimento?.replaceAll("-", "") || "",
  ie_sexo: store.state.user.registerForm?.ie_sexo || null,
});
const loading = reactive({ submit: false });

function handleClose() {
  router.replace({ name: "home" });
}

function handleSubmit() {
  if (checkPersonalForm(form) === "error")
    return store.commit("addToast", {
      summary: "Preencha todos os campos antes de prosseguir!",
      severity: "warn",
    });

  store.commit("setUserRegisterForm", form);
  router.push({ name: "register-finish" });
}

if (checkLoginForm(store.state.user.registerForm) === "error") router.replace({ name: "register-login" });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    id: "v-register-personal",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _createVNode(_unref(ObModal), {
      "onClick:close": handleClose,
      "onClick:background": handleClose
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      subtitle: _withCtx(() => [
        _hoisted_3
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(ObCancelButton), {
          "is-disabled": _unref(loading).submit,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["is-disabled"]),
        _createVNode(_unref(ObSubmitButton), {
          "is-loading": _unref(loading).submit
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(ObInputText), {
            modelValue: _unref(form).nm_pessoa_fisica,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).nm_pessoa_fisica) = $event)),
            "element-id": "register-nm_pessoa_fisica",
            width: "100%",
            placeholder: "Nome e Sobrenome",
            "is-required": "",
            "has-autofocus": ""
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(ObInputText), {
            modelValue: _unref(form).nm_apelido,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).nm_apelido) = $event)),
            "element-id": "register-nm_apelido",
            width: "100%",
            placeholder: "Apelido ou nome social"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(ObInputText), {
            modelValue: _unref(form).nr_cpf,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).nr_cpf) = $event)),
            "element-id": "register-nr_cpf",
            width: "206px",
            max: "14",
            placeholder: "999.999.999-99",
            mask: _unref(formatCPF),
            unmask: _unref(removeCPFMask),
            "is-required": ""
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["modelValue", "mask", "unmask"]),
          _createVNode(_unref(ObInputText), {
            modelValue: _unref(form).dt_nascimento,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).dt_nascimento) = $event)),
            "element-id": "register-dt_nascimento",
            width: "206px",
            max: "10",
            placeholder: "dd/mm/aaaa",
            mask: _unref(addDateMask),
            unmask: _unref(removeDateMask),
            "is-required": ""
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["modelValue", "mask", "unmask"]),
          _createVNode(_unref(ObInputText), {
            modelValue: _unref(form).nr_telefone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).nr_telefone) = $event)),
            "element-id": "register-nr_telefone",
            width: "calc(100% - 412px - 32px)",
            placeholder: "(99) 99999-9999",
            mask: _unref(formatPhone),
            unmask: _unref(removePhoneMask),
            max: "15",
            "is-required": ""
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["modelValue", "mask", "unmask"]),
          _createVNode(_unref(ObRadio), {
            modelValue: _unref(form).ie_sexo,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).ie_sexo) = $event)),
            "element-id": "ie_sexo",
            options: _unref(sexOptions)
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ])
      ]),
      _: 1
    })
  ], 40, _hoisted_1))
}
}

})